import { useState } from 'react';
import axios from 'axios';
import '../styles/Login.css';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';
import { API } from '../config/api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [erreur, setErreur] = useState('');
  const navigate = useNavigate();

  const parseJwt = (token) => {
    try {
      return JSON.parse(atob(token.split('.')[1]));
    } catch (e) {
      return null;
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setErreur('');

    if (!email || !password) {
      setErreur('Tous les champs sont obligatoires.');
      return;
    }

    try {
      const res = await axios.post(API+'/api/auth/login', {
        email,
        password,
      });

      const token = res.data.token;
      const decoded = parseJwt(token);

      localStorage.setItem('token', token);
      localStorage.setItem('role', decoded.role);
     
      const userRes = await axios.get(API+`/api/users/${decoded.id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      localStorage.setItem('user', JSON.stringify(userRes.data));

      // Navigate to appropriate dashboard based on role
      if (decoded.role === 'Admin' || decoded.role === 'admin') {
        navigate('/admin/dashboard');
      } else if (decoded.role === 'Tech' || decoded.role === 'tech' || decoded.role === 'technicien') {
        navigate('/technicien/consommation');
      } else {
        setErreur('Rôle utilisateur non reconnu');
      }

    } catch (err) {
      console.error('❌ Erreur lors de la connexion:', err);
      setErreur(err.response?.data?.error || 'Erreur serveur');
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <div className="login-left">
          <img src={logo} alt="Logo Abar" className="login-logo" />
          <h1>Abar</h1>
          <p>Bienvenue dans votre application de gestion d'eau. Veuillez vous connecter pour continuer.</p>
        </div>

        <div className="login-right">
          <h2>Connexion Admin</h2>
          <form onSubmit={handleLogin}>
            <input
              type="email"
              placeholder="Adresse e-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <div className="password-field">
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="Mot de passe"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <span onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? '👁️‍🗨️' : '👁️'}
              </span>
            </div>

            <div className="remember">
              <label>
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={() => setRememberMe(!rememberMe)}
                /> Se souvenir de moi
              </label>
            </div>

            {erreur && <div className="login-error">{erreur}</div>}

            <button type="submit" className="login-button">Se connecter</button>
          </form>
        </div>
      </div>
    </div>
  );
}
